import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxComponentDef } from '@df/ui/form/checkbox/checkbox.component.def';
@Component({
    selector: 'toggle',
    templateUrl: 'toggle.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleComponent),
            multi: true
        }
    ],
    standalone: true
})
export class ToggleComponent extends CheckboxComponentDef {}
